import React, { Component } from 'react'
import {
  HueSlider,
  LightnessSlider,
  AlphaSlider,
} from 'react-slider-color-picker'

export default class ColorPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      color: props.color,
    }
  }

  static getDerivedStateFromProps(nextProps) {
    return nextProps
  }

  _handleChangeColor(color) {
    this.setState({ color }, () => {
      this.props.onColorUpdated(color)
    })
  }

  render() {
    let { color } = this.state
    return (
      <div className="hsl">
        <div className="h row align-items-center">
          <div className="col">
            <HueSlider
              handleChangeColor={(color) => this._handleChangeColor(color)}
              color={color}
            />
          </div>
        </div>
        <div className="s row align-items-center my-1">
          <div className="col">
            <LightnessSlider
              handleChangeColor={(color) => this._handleChangeColor(color)}
              color={color}
            />
          </div>
        </div>
        <div className="l row align-items-center my-1">
          <div className="col">
            <AlphaSlider
              handleChangeColor={(color) => this._handleChangeColor(color)}
              color={color}
            />
          </div>
        </div>
      </div>
    )
  }
}
